export default __webpack_public_path__ + "static/media/violet-ship.5f94ba47.png";